'use strict';

angular.module('TurneroApp').component('coMonitor', {
    controller: [
        'monitorService',
        'TurneroAppConstant',
        '$interval',
        'generalService',
        function (monitorService, TurneroAppConstant, $interval, generalService) {
            var ctrl = this;
            //ctrl.ambiente = TurneroAppConstant.server.entorno;
            ctrl.activo = "";
            ctrl.demora = "";
            ctrl.Usuario = [];
            ctrl.Servidores = [];
            ctrl.intervalRefreshMonitor = undefined;

            ctrl.$onInit = function () {
                RefreshMonitor();

                if (!ctrl.intervalRefreshMonitor) {
                    ctrl.intervalRefreshMonitor = $interval(RefreshMonitor, 10000);
                }
            };

            ctrl.$onDestroy = function () {
                //cuando el componente se destruye se cancela el interval
                if (ctrl.intervalRefreshMonitor)
                    $interval.cancel(ctrl.intervalRefreshMonitor);
            };

            function RefreshMonitor() {

                var started = new Date().getTime();

                monitorService.GetRedisConnect().$promise.then(function (res) {

                    var ended = new Date().getTime();
                    var milliseconds = ended - started;

                    ctrl.activo = "ACTIVO";
                    ctrl.demora = milliseconds;

                }).catch(function (req) {
                    ctrl.activo = "INACTIVO";
                });
                
                monitorService.GetConexiones().$promise.then(function (res) {

                    if (res.Usuario)
                    {
                        ctrl.Usuario.min = res.Usuario.Minimo;
                        ctrl.Usuario.max = res.Usuario.Maximo;
                        ctrl.Usuario.cant = res.Usuario.Cantidad;
                        ctrl.Usuario.carga = res.Usuario.Carga;
                    }
                    
                    if (res.Servidores)
                    {
                        ctrl.Servidores = res.Servidores;
                    }                    

                }).catch(function (req) {

                });

                monitorService.VerificacionServidores().$promise.then(function (res) {
                    ctrl.Servidores_Status = res;

                }).catch(function (req) {

                });
            }

            ctrl.getVersion = function () {
                generalService.Get_Version().$promise.then(function (resultado) {
                    if (resultado) {
                        ctrl.ambiente = resultado.Entorno;
                    }
                })
            }

            ctrl.getVersion();
        }
    ],
    template: require('./monitor.html')
});



// WEBPACK FOOTER //
// ./app/components/monitor/monitorComponent.js